import tw from "tailwind-styled-components";
import { IoIosArrowForward } from "react-icons/io";
import { BoxTitle, Underline } from "../../Styles/PageStyles";
import { useNavigate } from "react-router-dom";

function SummaryCards({ apiData }) {
  const navigate = useNavigate();

  return (
    <>
      <Headers>
        <BoxTitle className="!mb-0 whitespace-nowrap items-center">
          Dashboard
          <Underline />
        </BoxTitle>
        <Wrapper>
          {[
            { label: "Properties", value: apiData?.propCount, link: '/landlord/property-list', textColor: 'text-gray-600' },
            { label: "Primary Tenants", value: apiData?.tenantCount, link: '/landlord/client', textColor: 'text-gray-600' },
          ].map((item, index) => (
            <Item key={index}>
              <span className="text-gray-400 text-sm">{item.label}</span>
              <span className={`text-lg font-semibold flex ${item.textColor} flex items-center cursor-pointer`} onClick={() => navigate(item.link)}>
                {item.value}
                <IoIosArrowForward
                  size={12}
                  className="ml-1 mt-0.5"
                />
              </span>
            </Item>
          ))}
        </Wrapper>
      </Headers>
    </>
  );
}

const Headers = tw.div`flex flex-col lg:flex-row justify-between space-y-4 lg:space-y-0`;
const Item = tw.div`flex flex-col`;
const Wrapper = tw.div`grid grid-cols-2 gap-6 `;
export default SummaryCards;
